import {readable, writable} from 'svelte/store'

const Lang = {
    'en': {
        'APP_PREFS': 'Application preferences',
        'CANCEL': 'Cancel',
        'EMAIL': 'Email',
        'ERROR_APP_USER_LOGIN': 'Error on username/password',
        'ERROR_APP_USER_PASSWORD': 'Error on current password',
        'ERROR_PASSWORD_MISMATCH': 'New passwords are different',
        'GENERAL_INFO': 'General information',
        'INFO_CHANNEL_SAVED': 'Channel saved',
        'INFO_CHANNEL_DELETED': 'Channel removed',
        'INFO_PASSWORD_UPDATED': 'Password updated',
        'INFO_TEMPLATE_DELETED': 'Template removed',
        'INFO_SETTINGS_UPDATED': 'User settings have been updated',
        'LANGUAGE': 'Language',
        'LICENSE_KEY': 'License key',
        'LOGIN': 'Login',
        'PASSWORD': 'Password',
        'PASSWORD_CHANGE': 'Change password',
        'PUBKEY': 'Public key (end-to-end encryption)',
        'SAVE': 'Save',
        'SETTINGS': 'Settings'
    },
    'fr': {
        'APP_PREFS': 'Préférences de l\'application',
        'CANCEL': 'Annuler',
        'EMAIL': 'Adresse email',
        'ERROR_APP_USER_LOGIN': 'Erreur sur nom d\'utilisateur / mot de passe',
        'ERROR_APP_USER_PASSWORD': 'Erreur sur le mot de passe actuel',
        'ERROR_PASSWORD_MISMATCH': 'Les nouveaux mots de passe sont différents',
        'GENERAL_INFO': 'Informations générales',
        'INFO_CHANNEL_SAVED': 'Channel sauvegardé',
        'INFO_PASSWORD_UPDATED': 'Mot de passe mis à jour',
        'INFO_SETTINGS_UPDATED': 'Les préférences ont été mises à jour',
        'LANGUAGE': 'Langue',
        'LICENSE_KEY': 'Numéro de licence',
        'LOGIN': 'Identifiant',
        'PASSWORD': 'Mot de passe',
        'PASSWORD_CHANGE': 'Changer le mot de passe',
        'PUBKEY': 'Clef publique (chiffrement point-à-point)',
        'SAVE': 'Enregistrer',
        'SETTINGS': 'Préférences'
        }
}

export const stLang = readable(Lang)
export const DBC_URL = 'https://dev.databroadcaster.io/v3'